import * as HttpService from "../../../../service/HttpService";

/** 报表模板 service **/


const BASIC_URL = HttpService.DOMAIN
const REBASIC_URL = " http://touchfish.top/mock/5ed31a3dc054360020e0281a/report-tempalte/"

/**
 * 获取用电单位
 */
export const getElectUnit = () => {
    return HttpService.get(BASIC_URL + "/distributionMeter/uintListOnAdd?userFlag=2");
}

/**
 * 获取设备树数据
 *  @param unitId 用电单位id
 */
export const getDevicesTreeData = (unitId) => {
    return HttpService.get(BASIC_URL + "/reportTmpl/getDevicesTreeData?id=" + unitId);
}


/**
 * 获取数据项列表
 * @param reportType 报表类型
 */
export const getDataItemList = (reportType, statisticCycleType) => {
    return HttpService.get(BASIC_URL + "/reportTmpl/getDataItemList?reportSubtype=" + reportType + "&reportStatPeriod=" + statisticCycleType)
}

/**
 * 新增报表模板
 * @param data 报表模板数据
 */
export const addReportTemplate = (data) => {
    return HttpService.post(BASIC_URL + "/reportTmpl/addOneReportTmplCustom", data);
}

/**
 * 通过模板id获取模板信息
 * @param id 模板id
 */
export const getTemplateInfoById = (id) => {
    return HttpService.get(BASIC_URL + "/reportTmpl/getReportTmplDetails?reportTmplId=" + id);
}


/**
 * 通过模板id获取模板信息
 * @param id 模板id
 */
export const editTemplate = (data) => {
    return HttpService.post(BASIC_URL + "/reportTmpl/modifyOneReportTmplCustom", data);
}



/**
 * 报表模板列表
 * @param data 报表模板数据
 */
export const getReportTemplate = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/reportTmpl/getReportTmplCustomBySearch", data);
}

/**
 * 删除报表模板
 * @param idStr 以逗号分割的模板id
 */
export const deleteReportTemplate = (idStr) => {
    return HttpService.post(HttpService.DOMAIN + "/reportTmpl/delOneReportTmplCustom?idStr=" + idStr);
}

/**
 * 报表模板编号模糊查询
 * @param reportTmplNo 输入内容
 */

export const getFuzzyReportTmplNo = (reportTmplNo) => {
    return HttpService.get(HttpService.DOMAIN + "/reportTmpl/getFuzzyReportTmplNo?reportTmplNo=" + reportTmplNo);
}
/**
 * 报表模板名称模糊查询
 * @param reportTmplNo 输入内容
 */

export const getFuzzyReportTmplName = (reportTmplName) => {
    return HttpService.get(HttpService.DOMAIN + "/reportTmpl/getFuzzyReportTmplName?reportTmplName=" + reportTmplName);
}
